import { grpcBaseUrl, isGrpcEnabled } from '../grpc/config';
import { authMetadata } from '../grpc/metadata';
import { emitLiveNotification, LIVE_NOTIFICATION_KINDS } from '../helpers/liveNotifications';

const { NotificationServiceClient } = require('./proto/acompanha/notification/v1/notification_grpc_web_pb.js');
const { SubscribeNotificationRequest } = require('./proto/acompanha/notification/v1/notification_pb.js');

const RECONNECT_BASE_MS = 2000;
const RECONNECT_MAX_MS = 30000;

let activeStream = null;
let reconnectTimer = null;
let reconnectAttempts = 0;
let subscriptionCounter = 0;

function clearReconnectTimer() {
    if (reconnectTimer) {
        window.clearTimeout(reconnectTimer);
        reconnectTimer = null;
    }
}

function scheduleReconnect(startStream) {
    clearReconnectTimer();
    const delay = Math.min(RECONNECT_BASE_MS * (2 ** reconnectAttempts), RECONNECT_MAX_MS);
    reconnectAttempts += 1;
    reconnectTimer = window.setTimeout(() => {
        startStream();
    }, delay);
}

function mapJobIntegrationEvent(event) {
    if (!event) {
        return null;
    }

    const actionValue = event.getAction();
    const action = actionValue === 1 ? 'started' : actionValue === 2 ? 'finished' : 'unknown';

    return {
        kind: LIVE_NOTIFICATION_KINDS.JOB_INTEGRATION_CHANGED,
        action,
        printerUuid: event.getPrinterUuid(),
        jobUuid: event.getJobUuid(),
        status: event.getStatus(),
        eventId: event.getEventId(),
    };
}

function handleNotificationResponse(response) {
    const notification = response.getNotification();
    if (!notification) {
        return;
    }

    if (notification.getAckEvent()) {
        reconnectAttempts = 0;
        return;
    }

    if (notification.getPingPongEvent()) {
        return;
    }

    const jobEvent = notification.getJobIntegrationChangedEvent();
    if (jobEvent) {
        const detail = mapJobIntegrationEvent(jobEvent);
        if (detail) {
            emitLiveNotification(detail);
        }
    }
}

function openNotificationStream() {
    if (!isGrpcEnabled() || !localStorage.getItem('access_token')) {
        return null;
    }

    subscriptionCounter += 1;
    const client = new NotificationServiceClient(grpcBaseUrl(), null, null);
    const request = new SubscribeNotificationRequest();
    request.setId(`dashboard-${subscriptionCounter}-${Date.now()}`);

    const stream = client.subscribe(request, authMetadata());

    stream.on('data', handleNotificationResponse);
    stream.on('error', (err) => {
        console.warn('[notifications] stream error', err?.message || err);
        activeStream = null;
        scheduleReconnect(openNotificationStream);
    });
    stream.on('end', () => {
        activeStream = null;
        scheduleReconnect(openNotificationStream);
    });

    activeStream = stream;
    return stream;
}

export function startLiveNotificationStream() {
    if (!isGrpcEnabled()) {
        return () => {};
    }

    openNotificationStream();

    return () => {
        clearReconnectTimer();
        reconnectAttempts = 0;
        if (activeStream) {
            activeStream.cancel();
            activeStream = null;
        }
    };
}
